import { Phone } from 'lucide-react';
import { Link } from 'react-router-dom';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sms-intake-assist/artifacts/zu79u6p6_logo_AACA.png";
const PHONE_NUMBER = "+1 803-403-0488";

export const Header = () => {
  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b border-slate-200 shadow-sm" data-testid="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/sms-consent" className="flex items-center gap-3" data-testid="header-logo-link">
            <img 
              src={LOGO_URL} 
              alt="Auto Accident Claim Assist" 
              className="h-14 md:h-20 w-auto"
            />
          </Link>

          {/* Call CTA */}
          <a 
            href={`tel:${PHONE_NUMBER.replace(/\s/g, '')}`}
            className="flex items-center gap-2 bg-[#2563EB] hover:bg-[#1D4ED8] text-white font-semibold py-2.5 px-4 md:px-6 rounded-lg transition-all transform hover:-translate-y-0.5 shadow-md"
            data-testid="header-call-button"
          >
            <Phone className="w-4 h-4" />
            <span className="hidden sm:inline">Call Now</span>
            <span className="sm:hidden">Call</span>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
